import "./EquityOrderConfirmStep.scss";
import template from "./EquityOrderConfirmStep.html";
import {IFormController, IOnDestroy, IOnInit} from "angular";
import {OrderVettingService} from "../../../services/OrderVettingService";
import {EquityOrderWizardStore} from "../../store/EquityOrderWizardStore";
import {Observable, ReplaySubject} from "rxjs";
import {isNotNull} from "../../../../../../js/util/UtilFunctions";
import {OrderVettingResponse, VettingOutcomes} from "../../../types/OrderVettingResponse";
import {extractOrderRequest} from "../../util/EquityWizardOrderUtil";
import {EquityWizardData} from "../../models/EquityWizardData";

export const EquityOrderConfirm = "tfEquityOrderConfirmStep";

export function equityOrderConfirm() {
    return {
        template,
        bindings: {
            store: "<"
        },
        controller: EquityOrderConfirmStepController,
        controllerAs: "ctrl"
    };
}

export class EquityOrderConfirmStepController implements IOnInit, IOnDestroy {

    /** @input */
    public readonly store: EquityOrderWizardStore;

    /** @ui-binding */
    public set vettingForm(form: IFormController | null) {
        if (form != null) {
            this.vettingForm$.next(form);
        }
    }

    private readonly vettingForm$ = new ReplaySubject<IFormController>(1);

    public readonly order$ = new ReplaySubject<EquityWizardData>(1);
    public readonly vettingResponse$ = new ReplaySubject<OrderVettingResponse>(1);
    public readonly vettingOutcomes$: Observable<VettingOutcomes>;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly orderVettingService: OrderVettingService) {
        this.vettingOutcomes$ = this.vettingResponse$
                                    .map((r) => r.vettingOutcomes)
                                    .publishReplay(1)
                                    .refCount();

        const hasValidationErrors = this.vettingOutcomes$.map((r) => r.errors);
        const validationSource = Observable.combineLatest(hasValidationErrors, this.vettingForm$);

        validationSource.takeUntil(this.destroyed$)
                        .subscribe(([hasErrors, form]) => this.updateValidation(hasErrors, form));
    }

    public async $onInit(): Promise<void> {
        this.watchOrder();
        this.watchVettingChanges();
    }

    private watchOrder() {
        this.store
            .current
            .takeUntil(this.destroyed$)
            .subscribe((order) => this.order$.next(order));
    }

    private watchVettingChanges() {
        this.store
            .current
            .takeUntil(this.destroyed$)
            .distinctUntilChanged((a, b) => (a.quote === b.quote) && (a.portfolio === b.portfolio))
            .map((d) => extractOrderRequest(d))
            .filter(isNotNull)
            .switchMap((order) => this.orderVettingService.validate(order.portfolioId, [order.order]))
            .subscribe((response) => this.vettingResponse$.next(response));
    }

    private updateValidation(hasErrors: boolean, form: IFormController) {
        form.$setValidity("vetting-errors", !hasErrors, form);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
